module.exports = __webpack_public_path__ + "img/cashback.5daab1fd.jpg";